//搜索规则限制
export const searchRule = (value) => {
    value = value.replace(/[\^\+\|\%\\\{\}\#\&\`]/g, '5a0c511f-3cc8-428c-860b-f747c16b2341')//特殊字符
    value = value.replace(/[\s]/g, '')//空格

    return value
}